import NoPay from "@/views/outsidesettle/nopay/NoPay"
export const nopay = {
    path: '/nopay',
    name: 'NoPay',
    component: NoPay
  }


// WEBPACK FOOTER //
// ./src/router/index/outsidesettle/nopay/index.js